import React, { Component } from 'react'
import { Volume2, VolumeX } from 'react-feather'
import ogg from '../../Assets/Audio/track.ogg'
import mp3 from '../../Assets/Audio/track.mp3'
import { Container, Controls } from './styles'
// autoplay="autoplay"
class Audio extends Component {
  constructor() {
    super()
    this.state = {
      muted: typeof localStorage.getItem('muted') ? JSON.parse(localStorage.getItem('muted')) : true,
    }
  }

  mute = () => {
    localStorage.setItem('muted', !this.state.muted)
    this.setState({
      muted: !this.state.muted
    })
  }

  render() {
    const button = this.state.muted ? (
      <Volume2 size={'100%'} />
    ) : (
      <VolumeX size={'100%'} />
    )

    return(
      <Container>
        <Controls onClick={() => this.mute()}>
          {button}
        </Controls>
        <audio
          controls loop="loop"
          muted={this.state.muted}
          autoPlay="autoplay"
          >
           <source src={ogg} type="audio/ogg" />
           <source src={mp3} type="audio/mpeg" />
        </audio>
      </Container>
    )
  }
}

export default Audio



// WEBPACK FOOTER //
// ./src/Components/Audio/index.js